import React from "react";
import ReactLoading from "react-loading";

interface LoadingStateProps {
  loadingMessage?: string;
  type?: "LOADING" | "PROCESSING";
}

const LoadingState: React.FC<LoadingStateProps> = ({ loadingMessage, type = "PROCESSING" }) => {
  const loadingType = type === "LOADING" ? "spin" : "bars";
  const color = "#94a3b8"; // Using primary-400 color from tailwind config
  const size = { height: "80px", width: "80px" };

  return (
    <div className="relative flex flex-col items-center justify-center w-full min-h-[50vh] gap-6 bg-transparent text-gray-400 font-sans text-base z-[100] pointer-events-none">
      <ReactLoading type={loadingType} color={color} height={size.height} width={size.width} />
      {loadingMessage && (
        <p className="relative text-center text-gray-600 font-medium max-w-md px-4">{loadingMessage}</p>
      )}
    </div>
  );
};

export { LoadingState };
